import { Link } from "react-router-dom";

const footerLinks = {
  guides: [
    { label: "Beginner Guide", href: "/oopbuy-spreadsheet-guide" },
    { label: "How to Use", href: "/oopbuy-spreadsheet-guide" },
    { label: "Comparisons", href: "/#comparison" },
    { label: "Safety Tips", href: "/#safety" },
  ],
  categories: [
    { label: "Shoes", href: "https://kaspreadsheet.com/category-911-Shoes.html", external: true },
    { label: "Hoodies/Sweaters", href: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html", external: true },
    { label: "T-Shirts", href: "https://kaspreadsheet.com/category-913-T-Shirts.html", external: true },
    { label: "Jackets", href: "https://kaspreadsheet.com/category-914-Jackets.html", external: true },
  ],
  more: [
    { label: "Bags", href: "https://kaspreadsheet.com/category-921-Bags.html", external: true },
    { label: "Accessories", href: "https://kaspreadsheet.com/category-920-Accessories.html", external: true },
    { label: "Jersey", href: "https://kaspreadsheet.com/category-919-Jersey.html", external: true },
    { label: "Sets", href: "https://kaspreadsheet.com/category-917-Sets.html", external: true },
  ],
  company: [
    { label: "Privacy Policy", href: "/#" },
    { label: "Disclaimer", href: "/#" },
    { label: "Contact", href: "https://kaspreadsheet.com/", external: true },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      {/* Main Footer */}
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-md">
                  <i className="ri-table-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">
                  Oopbuy Spreadsheet
                </span>
              </Link>
              <p className="text-sm text-background-50/60 leading-relaxed mb-6 max-w-xs">
                Your complete guide to mastering the Oopbuy spreadsheet shopping system. Tutorials, comparisons, and safety insights — all in one place.
              </p>
              <div className="flex items-center gap-3">
                {["ri-twitter-x-line", "ri-facebook-line", "ri-instagram-line", "ri-youtube-line"].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 flex items-center justify-center border border-background-50/20 rounded-lg text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all cursor-pointer"
                  >
                    <i className={`${icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Guides */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Guides &amp; Articles</h4>
              <ul className="space-y-2.5">
                {footerLinks.guides.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Shop Categories</h4>
              <ul className="space-y-2.5">
                {footerLinks.categories.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* More */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">More Categories</h4>
              <ul className="space-y-2.5">
                {footerLinks.more.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} Oopbuy Spreadsheet Guide. All rights reserved. This is an independent guide site — not affiliated with any spreadsheet provider.
            </p>
            <div className="flex items-center gap-4">
              {footerLinks.company.map((link) => (
                <span key={link.label}>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}